import { CSS, StyleProps } from "@shared/primitive-components"

export const Container = (props: StyleProps): CSS => ({
  display: `flex`,
  flexDirection: `column`,
  gridGap: props.theme.spacing(4),
  width: `100%`,
})

export const List = (): CSS => ({
  " a": {
    all: `unset`,
  },
})

export const ListItem = (props: StyleProps): CSS => ({
  cursor: `pointer`,
  display: `flex`,
  flexDirection: `row`,
  gridGap: props.theme.spacing(4),
  justifyItems: `center`,
  padding: `${props.theme.spacing(4)} ${props.theme.spacing(2)}`,
  fontFamily: props.theme.fonts.body.fontFamily,
  transition: `background 0.3s ease-in-out`,
  ":hover": {
    // taken from the table row hover color
    // does not appear to be in the theme?
    background: `rgba(0, 0, 0, 0.04)`,
  },
})
